var exports = {
  "Q": "x112a1f60--8cc5d3--text",
};

module.exports = exports;
